window.addEventListener("load", () => {
	const poll = setInterval(() => {
		const mapContainer = document.querySelector("#sc-store-locator-map");
		if (mapContainer) {
			clearInterval(poll);

			setTimeout(() => {
				configureLocations(mapContainer);

				const observer = new MutationObserver(() => configureLocations(mapContainer));

                observer.observe(mapContainer.querySelector(".sl-addresses"), { childList: true });

				const searchInput = mapContainer.querySelector("#sl-search-input");
				searchInput.placeholder = "Search";

				if (searchInput) {
					const clone = searchInput.cloneNode(true);
					clone.value = "";
					clone.id = "sl-search-input-clone";
					clone.placeholder = "Enter Zip Code";

					clone.addEventListener("input", e => {
						searchInput.value = e.target.value;
					});

					searchInput.insertAdjacentElement('afterend', clone);
				}
			}, 100);
		}
	}, 100);

	setTimeout(() => {
		clearInterval(poll);
	}, 15000);
});

function configureLocations(mapContainer) {
	const locationsList = mapContainer.querySelectorAll(".sl-addresses > li");
	locationsList.forEach(location => {
		const targetEl = location.querySelector("svg");
		const svgMarkup = `
                        <div class="custom_location_icon">
                            <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M58.0834 22.6665V49.5832H41.0834L32.5834 66.5832L24.0834 49.5832H7.08341V22.6665M7.08341 38.2498H41.0834M41.0834 43.9165V21.9582M46.7501 41.0832V32.5832M9.91675 9.9165L18.4167 1.4165M21.2501 9.9165L26.9167 1.4165M32.5834 9.9165V1.4165M63.7501 9.9165H1.41675L9.91675 1.4165H55.2501L63.7501 9.9165Z" stroke="#FB8C00" stroke-width="2.83333" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M32.5834 19.8332L26.9167 24.0832L21.2501 19.8332M32.5834 19.8332V9.9165M32.5834 19.8332L38.2501 24.0832L43.9167 19.8332M21.2501 19.8332L15.5834 24.0832L9.91675 19.8332M21.2501 19.8332V9.9165M9.91675 19.8332L5.66675 24.0832L1.41675 19.8332V9.9165M9.91675 19.8332V9.9165M46.7501 1.4165L55.2501 9.9165V19.8332M38.2501 1.4165L43.9167 9.9165V19.8332M43.9167 19.8332L49.5834 24.0832L55.2501 19.8332M55.2501 19.8332L59.5001 24.0832L63.7501 19.8332V9.9165" stroke="#FB8C00" stroke-width="2.83333" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>`;
		targetEl.outerHTML = svgMarkup;

		// location.querySelector("button.sl-address-action-bttn")?.remove();

		location.addEventListener("click", () => {
			location.querySelector(".sl-address-action-bttn")?.click();
		});
	});
}